import * as React from 'react';
import { Switch } from '@cian/ui-kit';
import { useDispatch, useSelector } from 'react-redux';

import { SwitchLabel } from '../../components/SwitchLabel';
import { TThunkDispatch } from '../../types/redux/thunk';
import { getComparisonSafe, setCompareType } from '../../actions/compare';
import { TCompareType } from '../../types/compareType';
import { selectCompareType } from '../../selectors/comparison';
import { trackOnlyDifferencesToggle } from './tracking';

export const DifferencesSwitchContainer: React.VFC = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const compareType = useSelector(selectCompareType);
  const checked = compareType === 'differences';

  const handleChange = React.useCallback(
    async (e: React.ChangeEvent, value: boolean) => {
      const compareType: TCompareType = value ? 'differences' : 'default';

      await dispatch(getComparisonSafe({ compareType }));
      dispatch(setCompareType(compareType));

      trackOnlyDifferencesToggle(compareType);
    },
    [dispatch],
  );

  return <Switch label={(<SwitchLabel text="Только различия" />) as any} checked={checked} onChange={handleChange} />;
};
